import Layout from 'layouts';
import { contentfulCustomerStoryType } from 'types';
import { getCustomerStorybySlug, getCustomerStoriesByPage } from 'lib/contentful';
import { serverLogger } from 'utils/serverLogger';
import { Head } from 'humanity/components/head';
import Masthead from 'legacy/components/masthead/secondaryMasthead';
import Story from 'legacy/components/customerStory/story';
import ResourceList from 'legacy/components/resourceList';
import CtaSection from 'legacy/components/ctaSection';

const CustomerStoryPage = ({ story = null }) => {
  const mastheadImage = {
    url: story.masthead?.desktopImage?.image?.url,
    altText: '', // story.masthead?.desktopImage?.altText,
  };

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    datePublished: story.publishDate,
    description: story.seoMetadata?.description,
    headline: story.title,
    image: story.image?.url,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${process.env.NEXT_PUBLIC_HI_BASE_URL}/customer-stories/${story.slug}/`,
    },
  };

  return (
    <Layout type="customerStory" layout={story.layout}>
      <Head
        title={story.seoMetadata?.title}
        description={story.seoMetadata?.description}
        image={story.seoMetadata?.image?.url}
        noIndex={story.seoMetadata?.noIndex}
        url={`${process.env.NEXT_PUBLIC_HI_BASE_URL}${story.seoMetadata?.canonicalUrl}`}
      >
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <Masthead
        eyebrow={story.masthead?.eyebrow}
        heading={story.masthead?.heading}
        headingHighlight={story.masthead?.headingHighlight}
        image={mastheadImage}
      />
      <Story story={story} />
      <ResourceList
        key={story.discoverMoreStoriesSection?.sys?.id}
        heading={story.discoverMoreStoriesSection?.heading}
        resources={story.discoverMoreStoriesSection?.resourcesCollection?.items}
      />
      <CtaSection
        title={story.ctaSection?.heading}
        content={story.ctaSection?.subheading}
        buttonText={story.ctaSection?.cta?.label}
        link={story.ctaSection?.cta?.url}
        variant="graySecondary"
      />
    </Layout>
  );
};

CustomerStoryPage.propTypes = {
  story: contentfulCustomerStoryType,
};

export const getStaticProps = async ({ params, preview = false }) => {
  try {
    const story = await getCustomerStorybySlug(params.slug, preview);

    if (!story) return { notFound: true };

    return { props: { story }, revalidate: 900 };
  } catch (err) {
    serverLogger.error(
      `Error fetching customer stories page with slug ${params.slug}`,
      err,
      err.response?.data
    );
    throw new Error(`Error fetching customer stories page with slug ${params.slug}`, {
      cause: err,
    });
  }
};

export const getStaticPaths = async () => {
  const { items } = await getCustomerStoriesByPage(
    process.env.NEXT_PUBLIC_PAGE_SIZE,
    0,
    false
  );

  const paths = items.map((story) => ({
    params: { slug: story.slug },
  }));

  return { paths, fallback: 'blocking' };
};

export default CustomerStoryPage;
